export const SET_PATIENTS = 'setPatients';
export const SET_PATIENT  = 'setPatient';
export const SORT_REGIMEN = 'sortRegimen';